import React, { useEffect, useState } from 'react';
import JBrowseService from '../services/jbrowse.service';
import EventBus from '../common/EventBus';
import { toast } from 'react-toastify';

// MUI imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const SaveSessionModal = (props) => {
  const {
    saveModalIsOpen,
    setSaveModalIsOpen,
    currentSession,
    setCurrentSession,
    setLoading,
    currentUser,
    currentAssembly,
    currentTracks,
    location,
    setSaveAlert,
    selectedCrop,
  } = props;

  const [name, setName] = useState('');

  useEffect(() => {
    if (currentSession) {
      setName(currentSession.name);
    }
  }, [currentSession]);

  const handleSaveSession = () => {
    setLoading(true);
    let newSession = { ...currentSession };
    newSession.name = name;

    let newView = { ...newSession.view };
    newView.tracks = newView.tracks.filter(
      (item) => !item.configuration.includes('BlastJob')
    );
    newSession.view = newView;

    const filteredTracks = currentTracks.filter(
      (item) => !item.name.includes('BlastJob')
    );

    setCurrentSession(newSession);

    let session = {
      user: currentUser,
      assembly: currentAssembly,
      tracks: filteredTracks,
      session: newSession,
      location: location,
      crop: selectedCrop,
    };

    JBrowseService.saveSession(session).then(
      (response) => {
        setTimeout(() => {
          setLoading(false);
          toast.success('Session saved successfully!');
        }, 500);
      },
      (error) => {
        setLoading(false);
        toast.error(
          'Error saving the session. Please refresh your browser and try again.'
        );
      }
    );
  };

  const toggleModal = () => {
    setSaveModalIsOpen(!saveModalIsOpen);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setSaveModalIsOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [setSaveModalIsOpen]);

  return (
      <Dialog
          open={saveModalIsOpen}
          onClose={toggleModal}
          PaperProps={{
              elevation: 5,
              sx: {
                  borderRadius: '12px',
                  width: '500px',  // Fixed width for consistency
                  py: 1,          // Vertical padding
                  overflowY: 'visible', 
                  boxShadow: 10 
              }
          }}
      >
          <DialogTitle
              sx={{
                  fontSize: '1.25rem',
                  fontWeight: 600,
                  py: 2,
                  pr: 6,  // Prevent close button overlap
                  borderBottom: '1px solid',
                  borderColor: 'divider'
              }}
          >
              Save Current Session
              <IconButton
                  aria-label="close"
                  onClick={toggleModal}
                  sx={{
                      position: 'absolute',
                      right: 12,
                      top: 12,
                      color: 'text.secondary',
                      '&:hover': {
                          backgroundColor: 'action.hover',
                          color: 'text.primary'
                      }
                  }}
              >
                  <CloseIcon fontSize="small" />
              </IconButton>
          </DialogTitle>

          <DialogContent dividers sx={{ py: 3 }}>
              <TextField
                  autoFocus
                  margin="dense"
                  id="sessionName"
                  label="Session Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  sx={{ mb: 2 }}
                  InputLabelProps={{ shrink: true }}
              />
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2, gap: 2 }}>
              <Button
                  variant="outlined"
                  onClick={toggleModal}
                  sx={{
                      textTransform: 'none',
                      px: 3,
                      borderRadius: '8px'
                  }}
              >
                  Cancel
              </Button>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveSession}
                  sx={{
                      textTransform: 'none',
                      px: 3,
                      borderRadius: '8px',
                      boxShadow: 'none',
                      '&:hover': {
                          boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)'
                      }
                  }}
              >
                  Save Session
              </Button>
          </DialogActions>
      </Dialog>

  );
};

export default SaveSessionModal;
